import { memo } from 'react';
import clsx from 'clsx';
import { ProductImage } from 'src/modules/common/components/ProductImage/ProductImage.tsx';
import { RenderHtml } from 'src/common/RenderHtml/RenderHtml';

type Props = {
    title: string;
    imgAlt: string;
    checked: boolean;
    disabled: boolean;
    onChange: () => void;
    imageURL: string;
    isRadio: boolean;
}

export const HomeActuator = memo(({
    title,
    checked,
    disabled,
    onChange,
    imageURL,
    imgAlt,
    isRadio,
}: Props) => (
    <button
        type="button"
        className={clsx({
            'vss-home-actuator': true,
            'vss-home-actuator--disabled': disabled,
        })}
        onClick={disabled ? () => null : onChange}
    >
        <div className="vss-home-actuator__header">
            <div className="vss-home-actuator__title">
                <RenderHtml data={title}/>
            </div>

            <div className={clsx({
                [`vss-home-actuator__${isRadio ? 'radio' : 'checkbox'}`]: true,
                [`vss-home-actuator__${isRadio ? 'radio' : 'checkbox'}--checked`]: checked,
            })}
            />
        </div>

        <div className="vss-home-actuator__image">
            <ProductImage imgSrc={imageURL} imgAlt={imgAlt}/>
        </div>
    </button>
));
